export default __webpack_public_path__ + "static/NeueMontreal-Regular-cc501734f415c767585c55447daa1ce9.eot";